export const LOADED = 2;
export const PARTS_PER_PAGE = 100;
export const PART_ITEM_HEIGHT = 20;
export const LIST_CONTAINER_HEIGHT = 400;
export const ITEMS_OFFSET = 150;
export const MAX_COUNT = ITEMS_OFFSET * 2 + 1;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/AllParts/constants.js